export default __webpack_public_path__ + "static/media/click.f01281d2.png";